/**
 * @fileoverview Renk ve Stil Sabitleri
 *
 * Emlakjet marka renkleri ve secim stilleri.
 *
 * @module utils/constants/colors
 */

/**
 * Marka renk paleti.
 * Emlakjet'in ana rengi emerald (zumrut yesili) ve turevleri.
 * Tailwind CSS emerald paleti ile uyumludur.
 *
 * @constant {Object}
 * @property {Object} emerald - Emerald renk tonlari (50-900)
 * @property {string} primary - Ana marka rengi (emerald-500)
 * @property {string} primaryLight - Acik varyant (emerald-400)
 * @property {string} primaryDark - Koyu varyant (emerald-600)
 * @property {string} primaryHover - Hover durumu rengi (emerald-700)
 */
export const COLORS = {
  // Primary brand color
  emerald: {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
    800: '#065f46',
    900: '#064e3b',
  },
  // Semantic aliases
  primary: '#10b981',       // emerald-500
  primaryLight: '#34d399',  // emerald-400
  primaryDark: '#059669',   // emerald-600
  primaryHover: '#047857',  // emerald-700

  // Badge colors
  badge: {
    opportunity: '#f59e0b',   // amber-500 - Fırsat
    priceDown: '#22c55e',     // green-500 - Fiyat düştü
    new: '#3b82f6',           // blue-500 - Yeni
    promoted: '#10b981',      // emerald-500 - Öne çıkan
  },
};

/**
 * Secim durumu stilleri.
 * Butonlar, togglelar ve filtre secenekleri icin CSS-in-JS stilleri.
 * Light ve dark mod icin ayri tanimlar icerir.
 *
 * @constant {Object}
 * @property {Object} selected - Secili durum stili (aktif buton)
 * @property {Object} popularLight - Populer secenek (light mod)
 * @property {Object} popularDark - Populer secenek (dark mod)
 * @property {Object} defaultLight - Varsayilan durum (light mod)
 * @property {Object} defaultDark - Varsayilan durum (dark mod)
 */
export const SELECTION_STYLES = {
  selected: {
    backgroundColor: COLORS.primary,
    color: '#ffffff',
    fontWeight: 600,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  },
  popularLight: {
    backgroundColor: 'rgba(16, 185, 129, 0.1)',
    color: COLORS.primaryHover,
  },
  popularDark: {
    backgroundColor: 'rgba(16, 185, 129, 0.2)',
    color: COLORS.primaryLight,
  },
  defaultLight: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: 'rgba(0, 0, 0, 0.7)',
  },
  defaultDark: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    color: 'rgba(255, 255, 255, 0.8)',
  },
};
